"use client";

import React from "react";
import Image from "next/image";
import { Typography, TextType } from "@components/atoms/typography/typography";
import { Button, ButtonType } from "@components/atoms/buttons/button";
import { SupportWidgetButton } from "@components/atoms/buttons/supportWidgetButton";

export function UnhandledErrorPage() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center px-6 py-24 lg:px-8 text-center bg-white-900">
            <Image
                src="/images/500.webp"
                alt="Error"
                width={440}
                height={440}
                priority
                className="w-[220px] sm:w-[440px] h-auto"
            />
            <div className="mt-3 w-full max-w-[720px]">
                <Typography type={TextType.SUB_CAPTION} position="center" color="black" marginBottom="8px">
                    Something went wrong
                </Typography>
                <Typography type={TextType.PARAGRAPH} position="center">
                    We couldn't load the latest version of this page. Please refresh and try again.
                </Typography>
            </div>
            <div className="mt-8 flex items-center justify-center gap-4 flex-col sm:flex-row">
                <Button
                    type={ButtonType.BUTTON_BASE}
                    color="blue"
                    className="!mt-0 !px-5 !py-3 !w-auto"
                    onClick={() => window.location.reload()}
                >
                    Refresh page
                </Button>
                <SupportWidgetButton>
                    <Typography type={TextType.LINK}>Contact support -&gt;</Typography>
                </SupportWidgetButton>
            </div>
        </div>
    );
}
